import { COMPONENTS } from '../../../components/components.registry';
import { SortConfig } from '../../../models';
import { DeepPartial } from '../../../utils';

export const DEFAULT_SORT_CONFIG: DeepPartial<SortConfig> = {
  components: {
    sort: COMPONENTS.PURE.SortDropdown,
    panel: null
  },
  iconSlot: 'dropdown-icon'
};
